const TableToolbar = ({
  left,
  right,
  className = "",
}) => {
  return (
    <div
      className={`app-table-toolbar ${className}`}
    >
      <div className="app-table-toolbar-left">
        {left}
      </div>

      <div className="app-table-toolbar-right">
        {right}
      </div>
    </div>
  );
};

export default TableToolbar;